import { pipe } from 'fp-ts/function';
import * as TE from 'fp-ts/TaskEither';
import * as R from 'ramda';

import { safeRunSubqlQuery } from "@/utils/requests";

export async function getOneChainDisplayName(endpoint: string, address: string) {
  const taskRunner = pipe(
    safeRunSubqlQuery<{
      identity: { displayName: string | null }
    }>(
      endpoint,
      `
        query Identity($identityId: String!) {
          identity(id: $identityId) {
            displayName
          }
        }
      `,
      {
        'identityId': address,
      }
    ),
    TE.map(R.path<string | null>(['identity', 'displayName'])),
  )
  return await taskRunner()
}